
import {
    defineComponent
} from 'vue';

import {
    Project
} from "@/helpers/interfaces";
import MyCard from "@/components/TimelinePage/MyCard.vue";

export default defineComponent({
    components: {
        MyCard
    },
    props: {
        project: {
            type: Object as() => Project,
            required: true
        },
    }

});
